export function Termos() {

  const conteudoTermo = ``

  return (
    <form
      className='form w-100'
    >
      <div className='text-center mb-10'>
        <h1 className='text-dark fw-bolder mb-3'>Termo e políticas de privacidade</h1>
        <div className='text-gray-500 fw-semibold fs-6 overflow-auto px-3 mh-500px'>
          {conteudoTermo}
        </div>

      </div>
    </form>
  )
}
